import SoundCache from '../SoundCache';
import Widget from './Widget';

export default class MessageWidget extends Widget {
	constructor({ container, api, socket, soundManager, voiceApi, mmlApi, baseUrl, hash }) {
		super({ container, api, socket, hash });
		this.soundManager = soundManager;
		this.voiceApi = voiceApi;
		this.mmlApi = mmlApi;
		this.baseUrl = baseUrl;
		this.soundCache = new SoundCache();
		this._intentionalSuspend = false;
		this._onAudioCtxStateChange = () => this._updateAudioAlert();
	}

	async loadConfig() {
		await Promise.all([
			super.loadConfig(),
			this.loadEventTypes(),
			this.loadGiftTypes(),
			this.loadGiftThresholds(),
			this.loadTextReplacements(),
			this.loadServiceIcons(),
			this.loadUserData(),
			this.loadChannels(),
		]);
	}

	applySettings(settings) {
		super.applySettings(settings);
		this.soundManager.setVolume((this.settings.volume ?? 100) / 100);
		this.soundManager.normalize = this.settings.normalizeVolume ?? false;
		const compressionAmount = this.settings.compressionAmount ?? 0;
		this.soundManager.setCompressor({
			enabled: compressionAmount > 0,
			ratio: 1 + (compressionAmount / 100) * 19,
			threshold: -10 - (compressionAmount / 100) * 40,
		});
		this._updateAudioAlert();
	}

	// Subclasses override to indicate whether any audio feature is active.
	_audioRequired() { return true; }

	_updateAudioAlert() {
		if(!this.audioResumeAlert) return;
		this.audioResumeAlert.hidden = !this._audioRequired() || this._intentionalSuspend || this.soundManager.audioCtx.state !== 'suspended';
	}

	_setupAudioMonitor() {
		this.soundManager.audioCtx.addEventListener('statechange', this._onAudioCtxStateChange);
		this._updateAudioAlert();
	}

	destroy() {
		this.soundManager.audioCtx.removeEventListener('statechange', this._onAudioCtxStateChange);
		super.destroy();
		this.soundCache.destroy();
	}
}
